import $ from 'jquery';
import Swiper from 'swiper/bundle';
import CONSTANT from '../../common/js/_constant';
import {nanoid} from 'nanoid';

$(document).ready(() => {
    if ($('.feature__card--container').length > 0) {
        adjustFeaturePanelWidths();
        initiateSwipers();
        updateSwiperWrapperClass();
        // R4 perf: throttle resize handling to at most once per paint via rAF,
        // matching the established pattern in header.js/quickLinks.js.
        let resizeTicking = false;
        $(window).on(CONSTANT.eventsListners.RESIZE, function () {
            if (resizeTicking) {return;}
            resizeTicking = true;
            window.requestAnimationFrame(function () {
                adjustFeaturePanelWidths();
                initiateSwipers();
                updateSwiperWrapperClass();
                resizeTicking = false;
            });
        });
        $('.feature-cta').on('click', function(e){
           let titleText = getTitleText($(this));
            var obj = dataLayerObj(e,titleText);
            createDataLayer('buttonClick', obj);
        });
        $('.feature__cards--prev-button').on('click', function(e) {
           const titleText = getTitleText($(this));
                        var obj = dataLayerObj(e,titleText,"Previous");
                        createDataLayer('List_Scroll_Previous', obj);
                      });
        $('.feature__cards--next-button').on('click', function(e) {
           const titleText = getTitleText($(this));
                var obj = dataLayerObj(e,titleText,"Next");
                createDataLayer('List_Scroll_Next', obj);
        });
    }
});

function dataLayerObj(e,title, buttonText) {
    var obj = {
        'articleName' : "",
        'blogCategory' : "",
        'blogPageCategory' : "",
        'buttonText' : buttonText ? buttonText : e.target.innerText,
        'pageSection' : title ? title : "",
        'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : document.querySelector("meta[name='template']").content == 'chli-clp-template' ? "Campaign":"Blog Detail Page",
        'planOption' : "",
        'productCategory' : "",
        'productName' : "",
        'question' : "",
        'source' : "",
        'searchTerm' : "",
        'videoTitle' : "",
        'bannerName' : "",

    };
    return obj;
}

function getTitleText(element) {
   const featureCardsContainer = element.closest('.featureCards');
   if (featureCardsContainer.length) {
     const chliTitleElement = featureCardsContainer.siblings('.chlititle');
     if (chliTitleElement.length) {
       return chliTitleElement.find('.chli_title h2').text().trim();
     }
   }
   return null;
}


let swiperInstances = []; // Array to hold multiple Swiper instances

function updateSwiperWrapperClass() {
    const $swiperContainers = $('.feature-panel-swiper');

    $swiperContainers.each(function(index) {
        const $swiperWrapper = $(this).find('.swiper-wrapper-switch.swiper-wrapper');
        if ($swiperWrapper.length) {
            if ($(window).width() <= 1023) {
                $swiperWrapper.addClass('row');
            } else {
                $swiperWrapper.removeClass('row');
            }

            const slideCount = $(this).find('.swiper-slide').length;
            if (slideCount < 5) {
                $swiperWrapper.addClass('justify-content-center');
            } else {
                $swiperWrapper.removeClass('justify-content-center');
            }
        }
    });
}

function adjustFeaturePanelWidths() {
    const $swiperContainers = $('.feature-panel-swiper');
    // Read once, before any of the per-panel width writes below - reading
    // this inside the loop forced a synchronous layout flush on every single
    // panel to answer a query whose result never changes between panels.
    const isNarrowViewport = $(window).width() <= 991;

    $swiperContainers.each(function(index) {
        const $panels = $(this).find('.scene--card .feature-panel__face--front');
        const $swiperSlide = $(this).find('.swiper-slide');
        $panels.each(function () {
            const $panel = $(this);
            let widthPercentage = 100;
            if (isNarrowViewport) {
                const midIndex = Math.floor($panels.length / 2);
                const panelIndex = $panels.index($panel);
                widthPercentage = 100 - Math.abs(midIndex - panelIndex) * 10;
                widthPercentage = Math.max(widthPercentage, 0);
            }
            $panel.css('width', `${widthPercentage}%`);
        });
        $swiperSlide.each(function(index){
            const id = nanoid();
            $(this).find('input[type="radio"]').prop('id',id);
            $(this).find('.feature-panel').prop('for',id);
        });
    });
}

function initiateSwipers() {
    const $swiperContainers = $('.feature-panel-swiper');

    $swiperContainers.each(function(index) {
        const $swiperContainer = $(this);
        if ($(window).width() > 991) {
            if (!swiperInstances[index]) {
                $swiperContainer.removeClass('row');
                swiperInstances[index] = new Swiper($swiperContainer[0], {
                    slidesPerView: 5.3,
                    spaceBetween: 20,
                    cssMode: true,
                    navigation: {
                        nextEl: $swiperContainer.find('.swiper-button-next')[0],
                        prevEl: $swiperContainer.find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $swiperContainer.find('.swiper-pagination')[0],
                    },
                    mousewheel: true,
                    keyboard: true,
                });
            }
        } else {
            if (swiperInstances[index]) {
                swiperInstances[index].destroy(true, true);
                swiperInstances[index] = null;
            }
        }
    });
}
